<template>
  <div class="feedback-page">
    <div class="page-head">
      <van-icon name="arrow-left" class="back" @click="$router.back()"></van-icon>
      <div class="title">{{ $t('m.problem_feedback') }}</div>
    </div>
    <div class="content" >
      <van-form class="feedback-form" @submit="onSubmit">
      <div class="UnableToRecharge"  >
         <div>{{ $t('m.problem_description') }}</div>
         <div class="rechargeResion">{{ $t('m.unable_recharge') }}</div>
      </div>

        <div class="tips-box">
          <div class="tips-item">
            <div class="failureMessage" >
            <span class="exclamationMark"  >!</span>
             {{failureMessage}}
            </div>
           
            <div class="tips-time">{{ currentTime }}</div>
          </div>
        </div>

        <van-field class="questionDescribe" v-model="detail" type="textarea" rows="4" :placeholder="$t('m.problem_description_placeholder')" maxlength="1000" />
  

        <div class="uploader-area">
          <div class="uploader-label">{{$t('m.problem_screenshot', { msg: $t('m.optional') })}}</div>
          <van-uploader
            :after-read="afterRead"
            :file-list="fileList"
            :max-size="10 * 1024 * 1024"
            multiple
            accept="image/*,video/*"
            :max-count="3"
            :before-read="beforeRead"
            @oversize="onOversize"
            @delete="deleteFile"
            @click-preview="onPreview"
          />
        </div>

        <div class="uploader-label">{{ $t('m.contact_information') }}</div>
        <van-field  class="emailWrapper"     v-model="email" :placeholder="$t('m.fill_in_email_address')" />

        <div class="submit-wrap">
          <van-button class="submitButton" native-type="submit" type="primary" @click="onSubmitClick">{{ $t('m.submit') }}</van-button>
        </div>

        <div class="notice">{{ $t('m.order_exception_notice') }}</div>
      </van-form>
    </div>
  
    

  </div>
</template>

<script>
import Vue from 'vue';
import { Button, Field, Uploader, Icon, Toast, Form, ImagePreview } from 'vant';
Vue.use(Button);
Vue.use(Field);
Vue.use(Uploader);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Form);
import { uploadFile } from '@/api/axios-client-new';
import { submitUserFeedback } from '@/api/pay';


export default {
  name: 'feedback',
  data() {
    return {
      description: '',
      fileList: [],
      email: '',
      detail: '',
      orderId: '',
      failureMessage: ''
    };
  },
  computed: {
    currentTime() {
      return this._currentTime || '';
    }
  },
  created() {
    // set initial time
    this._currentTime = this.formatDate(new Date());
    // 从路由获取 email 参数并设置到表单中
    const routeEmail = this.$route && this.$route.query && this.$route.query.email;
    if (routeEmail) {
      this.email = routeEmail;
    }
  },
  mounted() {
    this.currentTime = this.formatDate(new Date());
    // 获取充值金额并设置失败消息
    const rechargeAmount = localStorage.getItem('rechargeAmount') || '';
    const rechargeType = localStorage.getItem('rechargeType') || '';
    // 移除美元符号
    const amountValue = rechargeAmount.replace('$', '');
    this.failureMessage = this.$t('m.fawry_recharge_failed', { msg: amountValue, method: rechargeType });
  },
  methods: {
    beforeRead(file) {
      if (!file) return true;
      const rawFile = file.file || file;
      if (!rawFile) return true;
      if (rawFile.size > 10 * 1024 * 1024) {
        Toast(this.$t('m.upload_file_exceed_limit', { num: 10 }));
        return false;
      }
      return true;
    },
    formatDate(d) {
      const pad = (n) => (n < 10 ? '0' + n : n);
      const M = d.getMonth() + 1;
      return `${M}/${d.getDate()}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    afterRead(file) {
      console.log('[feedback] afterRead called:', file);
      // 上传文件到服务器并把返回的 fileUrl 放到 fileList
      // 支持多种 van-uploader 版本的参数：可能是 { file } 包装，也可能直接是 File 对象，或是数组
      let rawFile = null;
      if (Array.isArray(file)) {
        rawFile = file[0] && (file[0].file || file[0]);
      } else {
        rawFile = file.file || file;
      }
      if (!rawFile) {
        Toast(this.$t('m.cannot_read_file'));
        return;
      }
      Toast.loading({ message: this.$t('m.uploading'), duration: 0 });
      uploadFile(rawFile).then(({ data }) => {
        Toast.clear();
        console.log('[feedback] uploadFile response:', data);
        if (data && data.code == 1 && data.data && data.data.fileUrl) {
          // determine file type: 1 = video, 2 = image
          let fileType = 2;
          if (rawFile && rawFile.type) {
            if (rawFile.type.indexOf('video') === 0) {
              fileType = 1;
            } else {
              fileType = 2;
            }
          } else {
            const name = rawFile.name || '';
            const ext = name.split('.').pop().toLowerCase();
            const videoExts = ['mp4','mov','avi','mkv','webm','3gp'];
            if (videoExts.indexOf(ext) !== -1) {
              fileType = 1;
            } else {
              fileType = 2;
            }
          }
          this.fileList.push({
            url: data.data.fileUrl,
            name: rawFile.name || '',
            fileType: fileType,
            isUploading: false
          });
        } else {
          Toast(this.$t('m.upload_failed'));
        }
      }).catch((err) => {
        Toast.clear();
        const msg = err && err.message ? err.message : this.$t('m.upload_failed');
        Toast(msg);
      });
    },
    deleteFile(file) {
      const index = this.fileList.indexOf(file);
      if (index > -1) {
        this.fileList.splice(index, 1);
      }
    },
    onSubmitClick() {
      console.log('[feedback] current fileList:', this.fileList);
    },
    onOversize(file) {
      Toast(this.$t('m.upload_file_exceed_limit', { num: 10 }));
    },
    onPreview(file, detail) {
      const index = detail.index;
      const imageUrls = this.fileList.filter(item => item.fileType === 2).map(item => item.url);
      const instance = ImagePreview({
        images: imageUrls,
        startIndex: index,
        closeable: true,
        closeIconPosition: 'top-right',
        overlayStyle: { background: 'rgba(0,0,0,0.9)' }
      });
    },
    async onSubmit() {
        if (!this.detail) {
          Toast(this.$t('m.fill_in_all_required'));
        return;
      }
        // build payload
        const payload = {
          detail: this.detail,
          email: this.email,
          fileList: this.fileList,
          relatedData: (this.$route && this.$route.query && this.$route.query.orderNo) || '',
          feedbackPosition: (this.$route && this.$route.query && this.$route.query.from === 'pay') ? 4 : 1,
          typeId: (this.$route && this.$route.query && this.$route.query.from === 'pay') ? Number(process.env.FEEDBACK_TYPEID_PAY) : 0
        };
        try {
          Toast.loading({ message: this.$t('m.submitting'), duration: 0 });
          const res = await submitUserFeedback(payload);
          Toast.clear();
          if (res && res.data) {
            if (res.data.data === true) {
              this.$router.push({ path: '/feedback-success' });
            } else {
              Toast.fail(this.$t('m.submit_failed'));
            }
          } else {
            Toast.fail(this.$t('m.submit_failed'));
          }
        } catch (err) {
          Toast.clear();
          Toast.fail(err && err.message ? err.message : this.$t('m.submit_failed'));
        }
    }
  }
}
</script>

<style scoped>
.feedback-page {
  display:flex;
  flex-direction: column;
  height: 100vh;
}

.content {
  flex-grow: 1;
   background:  #fff ;
   box-sizing: border-box;
   overflow-y: auto;
   -webkit-overflow-scrolling: touch;
   padding-left: .28rem;
   padding-right: .28rem;
}
.page-head {
  display:flex;
  align-items:center;
  padding: .2rem .3rem;
  background: #fff;
  box-shadow: 0 1px 0 rgba(0,0,0,0.04);
  position: relative;
}
.page-head .back {
  font-size: .36rem;
}
.page-head .title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size:.36rem;
  font-weight:600;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  pointer-events: none;
}

.UnableToRecharge {
   font-weight: 600;
   margin-top: .32rem;
   font-size: .32rem;
}
.rechargeResion {
   margin-top: .32rem;
   color: #6365FF;
   font-size: .36rem;
}

.uploader-label {
  margin-bottom: .24rem;
  font-weight: 600;
}

.tips-box {
  background:#F4F6F9;
  padding: .24rem;
  border-radius: .2rem;
  margin-top: .2rem;
}

.failureMessage {
  color: #FF425E;

}

.exclamationMark {
  color:#F4F6F9;
  display: inline-block;
  width:.28rem;
  height: .28rem;
  background-color: #FF425E;
  text-align: center;
  border-radius: 50%;
  line-height: .28rem;
  font-size: .24rem;
  vertical-align: middle;
  margin-top: -0.02rem;
}

.tips-time {
  text-align: right;
  font-size: .24rem;
  margin-top: .32rem;
  color:#9497A2;
}
 
  /* questionDescribe textarea 背景色 */
  .questionDescribe .van-field__control {
    background: #F4F6F9;
    border-radius: 0.12rem;
    padding: 0.12rem;
  }

.questionDescribe {
  background: #F4F6F9;
  border-radius: .2rem;
  margin-top: .16rem;
}

.uploader-area {
  margin-top: .48rem;
}
.uploader-hint {
  color: #FF425E;
  font-size: .24rem;
  margin-bottom: .4rem;
}

.emailWrapper {
  background: #F4F6F9;
  border-radius: .2rem;
}

.submit-wrap {
  margin-top: .8rem;
  display: flex;
  justify-content: center;
}
.notice {
  margin-top: .32rem;
  font-size: .24rem;
  text-align: center;
  color: #9497A2
}

.submitButton {
  height: .88rem;
  border-radius: .44rem;
  width: 6rem;
  background: linear-gradient(90deg, #9259FE 0%, #6365FF 100%);
  color: #fff;
  border: none;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

</style>




// WEBPACK FOOTER //
// src/pages/feedback.vue